import { GetCsvExcelTradesApi } from "@/features/accounts/csv-excel/services/get-trades-api";
import { GetCsvExcelTradesRequestModel } from "@/features/accounts/csv-excel/services/get-trades-model";

/// CsvExcel明細一覧取得処理
export class GetCsvExcelTradesService {
  private getCsvExcelTradesApi = new GetCsvExcelTradesApi();

  /**
   * CsvExcel明細一覧取得API実行
   */
  public async getCsvExcelTrades(param: GetCsvExcelTradesRequestModel) {
    return await this.getCsvExcelTradesApi.getCsvExcelTrades(param);
  }
}
